import * as React from "react";
import styles from "./sale-product-component.module.scss";
import LazyProductImage from "../lazy-product-image/lazy-product-image";
import { transformImage } from "../../utils";
import { transformPrice } from "../../api/currency";
import { RESTProductItem } from "../../api/catalog";
interface ISaleProductComponent {
  name: string;
  imageWidth: number;
  className?: string;
  quantity?: number;
  triggerText?: string;
  product?: RESTProductItem;
  position?: number;
  hasWebp?: boolean;
  disableLazy?: boolean;
  brand_name?: string;
  locale: "fr" | "en";
  displayBrand?: boolean;
  variant?: "simple" | "selection";
  onClick?: (data: any) => void;
  currency: "eur" | "usd";
  wording: string;
  discountValue?: string;
}

export default class SaleProductComponent extends React.PureComponent<
  ISaleProductComponent,
  {}
> {
  public state = {
    idx: 0,
  };
  public getImage = (size: number) => {
    if (this.props.product.image) {
      return transformImage(
        this.props.product.image,
        size * this.props.imageWidth + "x" + size * this.props.imageWidth,
        true,
        this.props.hasWebp
      );
    }
    return "";
  };

  public render() {
    const isOutOfStock =
      this.props.product.price_range[0] === -1 &&
      this.props.product.price_range[1] === -1;

    return (
      <div className={(this.props.className || "") + " " + styles.product}>
        <LazyProductImage
          height="auto"
          width="100%"
          disableWebp={true}
          containerClassName={
            (this.props.quantity === 0 ? "empty " : "") + styles.imageContainer
          }
          // , ${this.getImage(3)} 3x
          srcSet={`${this.getImage(2)} 2x`}
          className={styles.main}
          src={this.getImage(1)}
          alt="image product"
          style={{
            opacity: isOutOfStock ? 0.3 : 1,
          }}
        >
          {this.props.discountValue ? (
            <div className={styles.discount}>{this.props.discountValue}</div>
          ) : undefined}
        </LazyProductImage>
        {this.props.displayBrand &&
        (this.props.product.title || this.props.brand_name) ? (
          <h5>{this.props.brand_name || this.props.product.title}</h5>
        ) : null}
        {!this.props.variant || this.props.variant !== "simple" ? (
          <>
            <h4>{this.props.name}</h4>
            {this.renderPrice(isOutOfStock)}
            {this.props.triggerText && this.props.quantity !== 0 ? (
              <p className={styles.stock}>{this.props.triggerText}</p>
            ) : null}
          </>
        ) : null}
      </div>
    );
  }

  private renderPrice(isOutOfStock: boolean) {
    if (isOutOfStock) {
      return <p style={{ color: "orange" }}>Out of stock</p>;
    }
    if (
      this.props.product.price_range[0] !== this.props.product.price_range[1]
    ) {
      const opt =
        this.props.product.options[this.props.product.options.length - 1];
      return (
        <>
          <p>
            {this.props.wording}{" "}
            {transformPrice(
              this.props.product.price_range[0],
              this.props.locale,
              this.props.currency
            )}{" "}
            {this.props.product.minimum_retail_price !==
              this.props.product.price_range[0] &&
            this.props.product.price_range[0] ? (
              <span>
                {transformPrice(
                  this.props.product.minimum_retail_price,
                  this.props.locale,
                  this.props.currency
                )}
              </span>
            ) : null}
          </p>
          {opt ? (
            <p style={{ color: "grey", fontWeight: "normal", fontSize: 12 }}>
              {opt.cardinality} {opt.label}
              {opt.cardinality > 1 ? "s" : ""}
            </p>
          ) : null}
        </>
      );
    }
    return (
      <p>
        {transformPrice(
          this.props.product.price_range[0],
          this.props.locale,
          this.props.currency
        )}{" "}
        {this.props.product.minimum_retail_price !==
          this.props.product.price_range[0] &&
        this.props.product.price_range[0] ? (
          <span>
            {transformPrice(
              this.props.product.minimum_retail_price,
              this.props.locale,
              this.props.currency
            )}
          </span>
        ) : null}
      </p>
    );
  }
}
